import {handleActions} from 'redux-actions';
import {SET_TARGET_AGE_OPTIONS} from './TargetAgeAction';
import {TargetAgeState} from '../TargetAgeTypes';

export const setTargetAgeOptions = (
    state: TargetAgeState,
    {payload}: any
) => {
    const {targetAgeData} = state;

    return {
        targetAgeData: [...targetAgeData, ...payload],
        isLoading: false,
    }
};

const initialState = {
    isLoading: true,
    targetAgeData: [],
};

const handlers = {
    [SET_TARGET_AGE_OPTIONS]: setTargetAgeOptions,
};

export default handleActions(handlers, initialState);
